<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import { IonPage, IonContent } from '@ionic/vue';
import BnImage from '@/components/BnImage.vue';

const app = getCurrentInstance();
const isPortal = app.appContext.config.globalProperties?.isPortal;

const isLoading = ref(true);
if (isPortal && window.subdomain) {
    setTimeout(() => {
        isLoading.value = false;
    }, 3000);
} else {
    isLoading.value = false;
}

const accountDetails = ref(null);

const setAccountDetails = (details) => {
    accountDetails.value = details;
    isLoading.value = false;
};

const portalHeader = computed(() => {
    return isPortal ? ' Portal' : '';
});
</script>

<template>
    <IonPage>
        <ion-header class="ion-no-border">
            <ion-toolbar>
                <v-toolbar flat density="default">
                    <v-toolbar-title>
                        <div class="d-flex align-center" @click="$router.push({ name: 'home' })">
                            <template v-if="isLoading">
                                <v-skeleton-loader type="avatar, heading" width="300px" />
                            </template>
                            <template v-else>
                                <v-avatar :size="50" class="mr-3">
                                    <BnImage v-if="accountDetails?.logo" :alt="accountDetails.name + ' Logo'" :img-src-prop="accountDetails.logo" :is-public="true" />
                                    <picture v-else style="width: 50px; height: 50px">
                                        <source srcset="/img/icons/bnlogo_50x50.webp" type="image/webp" />
                                        <img src="/img/icons/bnlogo_50x50.png" alt="BestNotes Logo" />
                                    </picture>
                                </v-avatar>
                                <span class="bold" style="font-family: 'Nexa, Poppins', sans-serif; font-size: 2.25rem; font-weight: 600">
                                    {{ accountDetails?.name || 'BestNotes' }}{{ accountDetails ? '' : portalHeader }}
                                </span>
                            </template>
                        </div>
                    </v-toolbar-title>
                </v-toolbar>
            </ion-toolbar>
        </ion-header>
        <IonContent>
            <div class="mt-2 mt-md-12">
                <v-main>
                    <v-container :class="$vuetify.display.name == 'xs' ? 'pa-0' : ''">
                        <div>
                            <router-view v-slot="{ Component }" @set-account-details="setAccountDetails">
                                <transition name="fade" mode="out-in">
                                    <component :is="Component" />
                                </transition>
                            </router-view>
                        </div>
                    </v-container>
                </v-main>
            </div>
        </IonContent>
        <ion-footer class="ion-no-border ion-no-padding">
            <ion-toolbar class="ion-no-padding">
                <v-footer app absolute>
                    <div class="text-center text-body-2 font-weight-medium">&copy; {{ new Date().getFullYear() }} BestNotes, LLC. All rights reserved</div>
                </v-footer>
            </ion-toolbar>
        </ion-footer>
    </IonPage>
</template>

<style lang="scss">
@use '@/assets/scss/bn.scss';

/* A bit of a hack to get Ionic and Vuetify to work together better. */
*,
::before,
::after,
.v-input__slot {
    -webkit-box-sizing: border-box !important;
    box-sizing: border-box !important;
}
// ios ample touch footer css
ion-footer.footer-toolbar-padding ion-toolbar:last-of-type {
    padding-bottom: var(--ion-safe-area-bottom, 0);
    background: #ffffff !important;
    --background: #ffffff !important;
}
ion-footer ion-item {
    --min-height: 32px !important;
    --padding-start: 0px !important;
}
</style>
